import React, { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { store } from './reducers';
import { BrowserRouter } from 'react-router-dom';
import { BladeProvider } from '@razorpay/blade/components';
import { bladeTheme } from '@razorpay/blade/tokens';
import GlobalStyles from 'GlobalStyles';
import { getThemePreference } from 'utils/getThemePreference';
import { RouterNavigationProvider } from './context/RouterNavigationProvider';
import { AppThemeBridge } from 'context/AppThemeContext';

export default ({ children }: PropsWithChildren<{}>) => (
  <Provider store={store}>
    <BrowserRouter>
      <BladeProvider themeTokens={bladeTheme} colorScheme={getThemePreference()}>
        <AppThemeBridge>
          <GlobalStyles />
          <RouterNavigationProvider>
            {children}
          </RouterNavigationProvider>
        </AppThemeBridge>
      </BladeProvider>
    </BrowserRouter>
  </Provider>
);
